import { useLocalSearchParams } from "expo-router";

import OrganizationForm from "@/features/invitations/components/organisms/OrganizationForm";

import { useInvitationsGetOrganizationQuery } from "@/generated/graphql";
import useSetPageTitle from "@/hooks/useSetPageTitle";

/**
 * Container component for updating an existing organization.
 * Fetches organization data by ID and renders the organization form.
 */
const UpdateOrganizationContainer = () => {
  const { organizationId } = useLocalSearchParams<{ organizationId: string }>();
  const { data } = useInvitationsGetOrganizationQuery({
    variables: { id: organizationId },
  });
  useSetPageTitle("Update Organization");

  return !data?.getOrganization ? null : (
    <OrganizationForm organization={data.getOrganization} />
  );
};

export default UpdateOrganizationContainer;
